module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.summary) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-aqua"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.summary.totalShippingLines))]), _vm._v(" "), _c('p', [_vm._v("Total Shipping Lines")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-green"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.formatCurrency(_vm.summary.totalInvoices)))]), _vm._v(" "), _c('p', [_vm._v("Total Revenue")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-yellow"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.formatCurrency(_vm.summary.totalProfit)))]), _vm._v(" "), _c('p', [_vm._v("Total Profit")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-red"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.summary.totalJobs))]), _vm._v(" "), _c('p', [_vm._v("Total Jobs")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.records.length > 0) ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "350",
      "options": _vm.topShippingLinesChartData.options,
      "series": _vm.topShippingLinesChartData.series
    }
  }) : _c('div', {
    staticStyle: {
      "height": "350px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "border": "1px solid #ddd",
      "border-radius": "4px",
      "background": "#f9f9f9"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#666"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart fa-2x"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("No data available")]), _vm._v(" "), _c('small', [_vm._v("Please load data to view charts")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-warning"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.records.length > 0) ? _c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "350",
      "options": _vm.shippingLinePerformanceChartData.options,
      "series": _vm.shippingLinePerformanceChartData.series
    }
  }) : _c('div', {
    staticStyle: {
      "height": "350px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "border": "1px solid #ddd",
      "border-radius": "4px",
      "background": "#f9f9f9"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#666"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart fa-2x"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("No data available")]), _vm._v(" "), _c('small', [_vm._v("Please load data to view charts")])])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Shipping Line-wise Growth Data")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export Excel\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('b-table', {
    staticClass: "text-center",
    attrs: {
      "items": _vm.records,
      "fields": _vm.tableFields,
      "tbody-tr-class": _vm.getRowClass,
      "striped": "",
      "bordered": "",
      "hover": "",
      "responsive": "sm"
    },
    scopedSlots: _vm._u([{
      key: "sn",
      fn: function(data) {
        return [_vm._v("\n          " + _vm._s(((_vm.currentPage - 1) * _vm.perPage) + data.index + 1) + "\n        ")]
      }
    }, {
      key: "shippingLineId",
      fn: function(data) {
        return [_c('span', {
          staticClass: "text-center d-block"
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "shippingLineName",
      fn: function(data) {
        return [_c('span', {
          staticClass: "text-left d-block"
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "totalJobs",
      fn: function(data) {
        return [_c('span', {
          staticClass: "text-center d-block"
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "totalInvoices",
      fn: function(data) {
        return [_c('span', {
          staticClass: "text-right d-block"
        }, [_vm._v(_vm._s(_vm.formatCurrency(data.value)))])]
      }
    }, {
      key: "totalExpenses",
      fn: function(data) {
        return [_c('span', {
          staticClass: "text-right d-block"
        }, [_vm._v(_vm._s(_vm.formatCurrency(data.value)))])]
      }
    }, {
      key: "totalProfit",
      fn: function(data) {
        return [_c('span', {
          staticClass: "text-right d-block",
          class: _vm.getProfitClass(data.value)
        }, [_vm._v("\n            " + _vm._s(_vm.formatCurrency(data.value)) + "\n          ")])]
      }
    }, {
      key: "avgInvoice",
      fn: function(data) {
        return [_c('span', {
          staticClass: "text-right d-block"
        }, [_vm._v(_vm._s(_vm.formatCurrency(data.value)))])]
      }
    }, {
      key: "avgProfit",
      fn: function(data) {
        return [_c('span', {
          staticClass: "text-right d-block",
          class: _vm.getProfitClass(data.value)
        }, [_vm._v("\n            " + _vm._s(_vm.formatCurrency(data.value)) + "\n          ")])]
      }
    }, {
      key: "profitPercentage",
      fn: function(data) {
        return [_c('span', {
          staticClass: "text-right d-block",
          class: _vm.getPercentageClass(data.value)
        }, [_vm._v("\n            " + _vm._s(data.value.toFixed(2)) + "%\n          ")])]
      }
    }, {
      key: "status",
      fn: function(data) {
        return [_c('span', {
          staticClass: "label",
          class: _vm.getStatusClass(data.value)
        }, [_vm._v("\n            " + _vm._s(data.value) + "\n          ")])]
      }
    }])
  }, [(_vm.summary) ? _c('template', {
    slot: "bottom-row"
  }, [_c('td', {
    staticClass: "text-center font-weight-bold bg-light",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
    staticClass: "text-center font-weight-bold bg-light"
  }, [_vm._v(_vm._s(_vm.summary.totalJobs))]), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold bg-light"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.summary.totalInvoices)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold bg-light"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.summary.totalExpenses)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold bg-light",
    class: _vm.getProfitClass(_vm.summary.totalProfit)
  }, [_vm._v("\n            " + _vm._s(_vm.formatCurrency(_vm.summary.totalProfit)) + "\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "bg-light",
    attrs: {
      "colspan": "4"
    }
  })]) : _vm._e()], 2), _vm._v(" "), (_vm.totalRows > 0) ? _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mt-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "mr-2 mb-0"
  }, [_vm._v("Show:")]), _vm._v(" "), _c('b-form-select', {
    staticClass: "w-auto",
    attrs: {
      "options": _vm.pageOptions,
      "size": "sm"
    },
    on: {
      "change": _vm.handlePerPageChange
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-muted"
  }, [_vm._v("entries")])], 1), _vm._v(" "), _c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "size": "sm",
      "first-number": "",
      "last-number": ""
    },
    on: {
      "change": _vm.changePage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n          Showing " + _vm._s(_vm.records.length ? ((_vm.currentPage - 1) * _vm.perPage + 1) : 0) + " to " + _vm._s(Math.min(((_vm.currentPage - 1) * _vm.perPage) + _vm.records.length, _vm.totalRows)) + " of " + _vm._s(_vm.totalRows) + " entries\n        ")])], 1) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-ship"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Top 10 Shipping Lines by Profit")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Shipping Line Performance Distribution")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-031a4b6e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/growthDashboard/ShippingLineWiseGrowthComponent.vue
// module id = 2355
// module chunks = 0